import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Chip"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 8.25V9.75H19.5V14.25H22.5V15.75H19.5V18C19.5 18.8284 18.8284 19.5 18 19.5H15.75V22.5H14.25V19.5H9.75V22.5H8.25V19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V15.75H1.5V14.25H4.5V9.75H1.5V8.25H4.5V6C4.5 5.17157 5.17157 4.5 6 4.5H8.25V1.5H9.75V4.5H14.25V1.5H15.75V4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V8.25H22.5ZM6 18H18V6H6V18ZM8.25 8.25V15.75H15.75V8.25H8.25ZM9.75 14.25H14.25V9.75H9.75V14.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Chip.vue"]]);
